import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'

interface UserOptions {
	allowHideTermedDependents: boolean
	isHideTermedDependentsEnabled: boolean
	allowClaimsAccess: boolean
	policyHolderName: string | null
	isClaimsAccessEnabled: boolean
}

const userOptionsDefault: UserOptions = {
	allowHideTermedDependents: false,
	isHideTermedDependentsEnabled: false,
	allowClaimsAccess: false,
	policyHolderName: null,
	isClaimsAccessEnabled: false
}

export const useUserSettingsStore = defineStore(
	'userSettings',
	() => {
		// ====---------------====
		// 🗄️ State
		// ====---------------====
		const displayName = ref<string>('')
		const tosChecked = ref<number | null>(null)
		const pcpSelectedMember = ref<string | null>(null)
		const userOptions = reactive<UserOptions>({ ...userOptionsDefault })

		// ====---------------====
		// 🎬 Actions
		// ====---------------====
		function $reset() {
			displayName.value = ''
			tosChecked.value = null
			Object.assign(userOptions, userOptionsDefault)
		}

		function getOptions(): UserOptions {
			return userOptions
		}

		function updateOptions(args: UserOptions) {
			Object.assign(userOptions, args)
		}

		// ====---------------====
		// 🚀 Exports
		// ====---------------====
		return {
			displayName,
			tosChecked,
			pcpSelectedMember,
			userOptions,
			getOptions,
			updateOptions,
			$reset
		}
	},
	{
		persist: {
			storage: sessionStorage
		}
	}
)
